/**
 * Imports here will be global to every RCP final JS file
 */

import '../../global_base_builder.js';

import RCP from '../../../../assets/js/Vertical/RCP/RCP.js';
RCP();

import MastheadFull from '../../../../assets/js/Sections/Masthead/MastheadFull.js';
import MastheadShort from '../../../../assets/js/Sections/Masthead/MastheadShort.js';
import MastheadSites from '../../../../assets/js/Sections/Masthead/MastheadSites.js';
import StaffMenu from '../../../../assets/js/Sections/Masthead/StaffMenu.js';

import rc_meta from '../../../../assets/js/RCMeta';

import FooterLinks from '../../../../assets/js/Sections/Footer/FooterLinks.js';

import PromoOffer from "../../../../assets/js/PromoOffer/PromoOffer";

import footer_scripts from '../../../../assets/js/Vertical/RCP/FooterScripts.js'; // Replacing footer_includes_before_body.js
footer_scripts();

import StatsCounter from '../../../../assets/js/Analytics/StatsCounter.js';
StatsCounter();